import React from 'react';
import BlogTextBlock from './BlogTextBlock';
import BlogStatsBlock from './BlogStatsBlock';
import BlogVideoBlock from './BlogVideoBlock';
import BlogCarouselBlock from './BlogCarouselBlock';
import BlogGalleryGrid from './BlogGalleryGrid';
import BlogHeroSlider from './BlogHeroSlider';
import BlogDivider from './BlogDivider';
import BlogPullQuote from './BlogPullQuote';
import BlogImageDuo from './BlogImageDuo';
import BlogProductsBlock from './BlogProductsBlock';
import BlogImageBlock from './BlogImageBlock';
import BlogRelatedPostsBlock from './BlogRelatedPostsBlock';
import BlogWpSection from './BlogWpSection';

const BLOCK_MAP = {
  text: BlogTextBlock,
  stats: BlogStatsBlock,
  video: BlogVideoBlock,
  carousel: BlogCarouselBlock,
  gallery: BlogGalleryGrid,
  hero_slider: BlogHeroSlider,
  divider: BlogDivider,
  separator: BlogDivider,
  pullquote: BlogPullQuote,
  image: BlogImageBlock,
  image_duo: BlogImageDuo,
  products: BlogProductsBlock,
  related_posts: BlogRelatedPostsBlock,
  wp_section: BlogWpSection,
};

export default function BlogBlockRenderer({ block }) {
  const Component = BLOCK_MAP[block.type];
  if (!Component) return null;
  return (
    <div className="blog-block" data-block-type={block.type}>
      <Component data={block.data} />
    </div>
  );
}
